import {
  SECTIONS_LOADING,
  SECTIONS_SUCCESS,
  SECTIONS_ERROR,
  CALCULATE_PROGRESS,
  COMPLETE_HOME_SECTION_SUCCESS,
  STATES_SUCCESS,
  ZIP_LOADING,
  ZIP_SUCCESS,
  ZIP_ERROR,
  SET_IS_APP_ACCESS_PAID,
  SET_APP_ACCESS_TYPE,
  SET_APP_PRODUCTS,
  SET_ORDERS,
  SET_PERSONAL_EDIT_LIMIT,
  SET_ADDRESS_EDIT_LIMIT,
  FETCH_USER_APP,
  USER_APP_ACCESS_ERROR,
  USER_APP_ACCESS_SUCCESS,
  SET_IS_APP_CLOSED,
} from '@/app/main/store/types';
import { DEFAULT_CPA_APP_ID, DEFAULT_REGULAR_USER_APP_ID } from '@/constants';

export const mutations = {
  [SECTIONS_LOADING]: (state) => {
    state.sectionsLoadingStatus = 'loading';
  },
  [SECTIONS_SUCCESS]: (state, data) => {
    state.sectionsLoadingStatus = 'success';
    state.isEasyFilingPaid = data.isEasyFilingPaid;
    state.sections = data.sections;
    state.sections.forEach((item) => {
      const indexMenuItem = state.menuItems.findIndex(value => value.title === item.sectionName);
      if (indexMenuItem >= 0) {
        state.menuItems[indexMenuItem].completed = item.isCompleted;
      }
    });
    state.currentApplicationData = data;
    state.currentYearUserApplicationId = data.currentYearUserApplicationId || data.id;
  },
  [SECTIONS_ERROR]: (state) => {
    state.sectionsLoadingStatus = 'error';
  },
  [USER_APP_ACCESS_ERROR]: (state) => {
    state.applicationAccessStatus = 'error';
  },
  [USER_APP_ACCESS_SUCCESS]: (state) => {
    state.applicationAccessStatus = 'success';
  },
  [CALCULATE_PROGRESS]: (state, data) => {
    state.formProgress = data;
  },
  [COMPLETE_HOME_SECTION_SUCCESS]: (state) => {
    state.sectionsLoadingStatus = 'success';
    state.menuItems[0].completed = true;
  },
  [STATES_SUCCESS]: (state, resp) => {
    state.addressLoadingStatus = 'success';
    resp.forEach(item => state.states.push(item.abbreviation));
    state.states.sort();
  },
  [ZIP_LOADING]: (state) => {
    state.zipCodeLoading = true;
  },
  [ZIP_SUCCESS]: (state, resp) => {
    state.zipCodeData = resp;
    state.zipCodeLoading = false;
  },
  [ZIP_ERROR]: (state) => {
    state.zipCodeLoading = false;
  },
  [SET_IS_APP_ACCESS_PAID]: (state, data) => {
    state.isAppAccessPaid = data;
  },
  [SET_APP_ACCESS_TYPE]: (state, { appAccessType, roles }) => {
    if (appAccessType != null) {
      if (roles?.length > 0) {
        state.appAccessType = DEFAULT_CPA_APP_ID;
      } else {
        state.appAccessType = appAccessType || DEFAULT_REGULAR_USER_APP_ID;
      }
    }
  },
  [SET_APP_PRODUCTS]: (state, data) => {
    state.appProducts = data;
  },
  [SET_ORDERS]: (state, data) => {
    state.orders = data;
  },
  [SET_PERSONAL_EDIT_LIMIT]: (state, data) => {
    state.isPersonalEditLimited = data.isPersonalProfileEditLimited;
  },
  [SET_ADDRESS_EDIT_LIMIT]: (state, data) => {
    state.isAddressEditLimited = data.isAddressEditLimited;
  },
  [FETCH_USER_APP]: (state, userApp) => {
    state.currentUserApplication = userApp;
  },
  [SET_IS_APP_CLOSED]: (state, data) => {
    state.isAppClosed = data;
  },
};
